import { render, staticRenderFns } from "./FormulaRaw.vue?vue&type=template&id=24d47e8a&scoped=true"
import script from "./FormulaRaw.vue?vue&type=script&lang=js"
export * from "./FormulaRaw.vue?vue&type=script&lang=js"
import style0 from "./FormulaRaw.vue?vue&type=style&index=0&id=24d47e8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d47e8a",
  null
  
)

export default component.exports